<template lang="pug">
  .cost-centers-filter
    //- span.filter-title {{ $t('common.docking_station_filter') }}
    el-select(
      v-model='selectedInfoType'
      filterable
      :placeholder="$t('placeholder.select_dock')"
      @change="emitChangeEvent"
    )
      el-option(
        v-for='infoType in infoTypes'
        :key='infoType.id'
        :label='infoType.name'
        :value="infoType.value"
      )
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FilterInfoTypeDropdown",

  props: {
    value: {
      type: String,
      default: "",
    },
  },

  computed: {
    selectedInfoType: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    ...mapState("auth", ["user"]),

  },

  data() {
    return {
      infoTypes: [
        { name: "All", value: '' },
        { name: "Humidity", value: 'humidity' },
        { name: "Temperature", value: 'temperature' },
        { name: "Conductivity", value: 'conductivity' },
        { name: "PH", value: 'ph' },
        { name: "Nitrogen", value: 'nitrogen' },
        { name: "Phosphorus", value: 'phosphorus' },
        { name: "Potassium", value: 'potassium' }
      ],
    };
  },

  methods: {
    emitChangeEvent(values) {
      this.$emit('onChange', values)
    }
  },
};
</script>
